var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import manualAssetDataUpdate from '../../requests/asset/manualAssetDataUpdate';
/**
 *
 */
var UpdateManualAssetDataCommand = /** @class */ (function (_super) {
    __extends(UpdateManualAssetDataCommand, _super);
    function UpdateManualAssetDataCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param manualAssetModel ManualAssetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateManualAssetDataCommand.prototype.execute = function (manualAssetModel, organisationId, intl) {
        var location = manualAssetModel.location, fuelUsedInLiters = manualAssetModel.fuelUsedInLiters, cumulativeOperatingHoursValue = manualAssetModel.cumulativeOperatingHoursValue;
        // If one of the fields is null, the API sets that object to null.
        var data = {
            location: (location.latitude == null || location.latitude === 0) ||
                (location.longitude == null || location.longitude === 0) ||
                location.timestamp == null ? null : location,
            fuelUsedInLiters: fuelUsedInLiters.timestamp == null || fuelUsedInLiters.value == null ? null : fuelUsedInLiters,
            cumulativeOperatingHoursValue: cumulativeOperatingHoursValue.timestamp == null || cumulativeOperatingHoursValue.value == null ? null : cumulativeOperatingHoursValue
        };
        this.intl = intl;
        this.manualAssetModel = manualAssetModel;
        var promise = manualAssetDataUpdate(data, organisationId, manualAssetModel.id);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateManualAssetDataCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.manualAssetModel)), 'dark', true);
    };
    return UpdateManualAssetDataCommand;
}(Command));
export default UpdateManualAssetDataCommand;
